import React from 'react';
import { useValidation } from '../Hooks/useValidation';
import { useLocale } from '../i18n/localeContext';

const ValidationTest = () => {
  const { validation, loading } = useValidation();
  const { locale } = useLocale();

  if (loading) {
    return <div>Cargando validaciones...</div>;
  }

  return (
    <div>
      
    </div>
  );
};

export default ValidationTest;
